{
  "version": 1,
  "asset_id": "5b31cd8a-6471-4063-a4d3-ac019e6d3392",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/5b31cd8a-6471-4063-a4d3-ac019e6d3392/svc-content-strategy-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/5b31cd8a-6471-4063-a4d3-ac019e6d3392/svc-content-strategy-1200.avif",
  "original_filename": "svc-content-strategy-1200.avif",
  "size": 13541,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:42Z"
}
